"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAce = _interopRequireDefault(require("react-ace"));

require("ace-builds/src-noconflict/theme-monokai");

require("ace-builds/src-noconflict/mode-json");

require("ace-builds/src-noconflict/mode-python");

require("ace-builds/src-noconflict/mode-golang");

require("ace-builds/src-noconflict/mode-javascript");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const InputCode = _ref => {
  let {
    style
  } = _ref,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/_react.default.createElement(_reactAce.default, _extends({
    setOptions: {
      useWorker: false
    }
  }, props, {
    style: _objectSpread({
      zIndex: 0
    }, style)
  }));
};

InputCode.propTypes = {
  theme: _propTypes.default.string,
  name: _propTypes.default.string,
  mode: _propTypes.default.oneOf(['json', 'python', 'golang', 'javascript']).isRequired,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  fontSize: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  tabSize: _propTypes.default.number,
  style: _propTypes.default.oneOfType([_propTypes.default.any])
};
InputCode.defaultProps = {
  theme: 'monokai',
  name: 'InputCode',
  value: undefined,
  placeholder: '',
  width: '500px',
  height: '500px',
  fontSize: 12,
  readOnly: false,
  tabSize: 2,
  style: undefined
};
var _default = InputCode;
exports.default = _default;